import { override, makeObservable } from 'mobx';

import { MedicationStatus } from 'chaika-enums';

import { store } from '@store';
import { List } from '@store/abstract/List';
import { Medications, MedicationParams } from './Medications';

export interface MedicationFilterParams {
    isActive: boolean;
}

export class MedicationList extends List<Medications, MedicationParams, MedicationFilterParams> {
    constructor(medications: MedicationParams[]) {
        super();
        makeObservable(this);

        this.set(medications || []);

        this.filterParams = { isActive: true };
    }

    @override
    public get ids(): string[] {
        return store.entry.isViewMode
            ? (Array.from(this.list.keys()) as string[])
            : this.serialize()
                  .filter(item => item.status !== MedicationStatus.Deleted)
                  .map(item => item.id);
    }

    public serialize(): MedicationParams[] {
        const medications: MedicationParams[] = [];

        this.list.forEach(medication => {
            medications.push(medication.serialize());
        });

        return medications;
    }

    public getSize(): number {
        return this.filteredValues.length;
    }

    protected create(params: MedicationParams): Medications {
        return new Medications(params);
    }

    protected filterValue(value: Medications, filterParams: MedicationFilterParams): boolean {
        let res = true;

        if (filterParams.isActive) {
            res = value.status === MedicationStatus.Active;
        }

        return res;
    }
}
